import * as ohm from 'ohm-js';

export const fglGrammar = ohm.grammar(String.raw`
  FGL {
    Layout         = (Command | Text)*
    Command        = QrCommand | GenericCommand
    GenericCommand = "<" CmdName Params? ">"
    QrCommand      = "<" "QR" Params? ">" "{" QrText "}"
    QrText         = (~"}" any)+
    CmdName        = letter+
    Params         = paramList
    number         = digit+
    paramList      = number ("," number)*
    Text           = (~"<" any)+
  }
`);
